import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { BehaviorSubject } from 'rxjs';
import { useObservable } from 'observable-hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProfile } from '../../profile';
import { Menu } from '../menu/Menu';
import { createWalkthroughManager } from '../../walkthrough/walkthrough';

// NOTE: This is not the real website. This is a mocked website that mimics the Django
// website. It is basically the React menu and the PageContainer merged into one component
// to allow for writing Storybook tests that need to navigate through pages via the menu, the
// walkthrough tests for example.
export function Website({ children }) {
    const profile = useProfile();
    const location = useLocation();
    const navigate = useNavigate();

    const locationRef = useRef();

    useEffect(() => {
        locationRef.current = location;
    }, [location]);

    // Subject that can be used by the walkthrough to fold open menu paths.
    const forceMenuOpenById$ = useObservable(() => new BehaviorSubject());

    useEffect(() => {
        const manager = createWalkthroughManager();
        manager.loadSchema({
            demoMeasuringPoint: 99,
            forceMenuOpenById$,
            getLocation() {
                return locationRef.current;
            },
            navigate,
        });
    }, [forceMenuOpenById$, navigate]);

    return (
        <>
            <Menu profile={profile} forceMenuOpenById$={forceMenuOpenById$} spaMode={true} />
            {children}
        </>
    );
}
Website.propTypes = {
    children: PropTypes.node.isRequired,
};
